import React from 'react';

export const pageMeta = {
  "name": "DOM Nodes",
  "link": "/javascript/dom/nodes"
};

export default function JavascriptDomNodes() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">DOM Nodes</h2>
      <p>Route: /javascript/dom/nodes</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
